module.exports = __webpack_public_path__ + "img/book_select.e83ca854.svg";